import { useParams } from 'react-router-dom'
import { useCallback } from 'react'

import { useGlobalContext } from '../../../../../context/ContextGlobal'
import {
  addDocument,
  addSubDocument,
  getDocuments,
  getSubDocumentsWithQuery,
  updateArrayInDocument,
  updateSubDocument,
} from '../../../../../firebase/firestore'
import { TryCatch } from '../../../../../utils/general'
import { SetHistoryEvent } from '../../../../../utils/requests'
import { DateTimeNow, TimestampNowSP } from '../../../../../utils/dates'
import { TransformationforMask } from '../../../../../utils/masks'

export const useModalAddjobOffers = (setActiveModal) => {
  const {
    user,
    setAlerts,
    loading,
    setLoading,
    dataContext,
    setDataContext, // contexto que guarda dados de lista para a pagina
    infosContext,
    setInfosContext, // contexto que guarda dados adicionais para a pagina funcionar
    formContext,
    setFormContext, // contexto que guarda dados de formularios da pagina
  } = useGlobalContext()

  const { id } = useParams()

  // const navigate = useNavigate()
  const getDatas = async () => {
    const getJobOffers = await getSubDocumentsWithQuery('events', id, 'jobOffers', 'status', '!=', 'deleted')

    const joboffersOrdered = (getJobOffers || []).sort((a, b) => {
      const turnoA = parseInt(a.round)
      const turnoB = parseInt(b.round)

      if (turnoA !== turnoB) return turnoA - turnoB

      if (a.date !== b.date) return a.date.localeCompare(b.date)

      return 0
    })

    setDataContext((prev) => ({ ...prev, jobOffers: joboffersOrdered }))
  }

  const getInfos = async () => {
    const getPositions = await getDocuments('cargos')
    const positionsById = getPositions.reduce((acc, curr) => {
      acc[curr.id] = curr.nome
      return acc
    }, {})
    // // console.log(positionsById)
    setInfosContext((prev) => ({ ...prev, positions: getPositions, positionsById }))
  }

  const FetchGetdatas = useCallback(async () => {
    await TryCatch(getDatas, setLoading, setAlerts)
  }, [])

  const FetchGetInfos = useCallback(async () => {
    await TryCatch(getInfos, setLoading, setAlerts)
  }, [])

  const schemaJobOffer = (values) => {
    if (values === undefined) {
      setAlerts((prev) => [
        ...prev,
        {
          type: 'error',
          title: 'Campos Vazios',
          msg: 'Os Campos obrigatórios estão vazios, preencha-os corretamente e tente novamente.',
        },
      ])
      return {}
    }

    const vestments = values?.vestments || '0'
    const form = values?.form || []

    // if (vestments === '1') {
    //   const hasSelectVestmentsInForm = form.some((item) => item.type === 'vestments')
    //   if (!hasSelectVestmentsInForm) {
    //     setAlerts((prev) => [
    //       ...prev,
    //       {
    //         type: 'error',
    //         title: 'Vestimentas não selecionadas',
    //         msg: 'Selecione uma vestimenta para criar uma pergunta no formulario.',
    //       },
    //     ])
    //     return {}
    //   }
    // }

    return {
      round: values?.round,
      amountJob: values?.amountJob || '0',
      date: values?.date || '',
      hrCheckin: values?.hrCheckin || '',
      hrCheckout: values?.hrCheckout || '',
      hrStart: values?.hrStart || '',
      idPosition: values?.idPosition || '',
      status: values?.status || 'closed',
      value: values?.value || '0',
      vestments,
      food: values?.food || '0',
      food_value: values?.food_value || '0',
      transportAllowance: values?.transportAllowance || '0',
      transportAllowance_value: values?.transportAllowance_value || '0',
      register: values?.register || '',
      payment: values?.payment || '',
      dtPayment: values?.dtPayment || '',
      form,
    }
  }

  const addJobOffers = async () => {
    const idEvent = id

    // se não possuir a permissão
    if (!user.user.permissions.jobOffers_add) {
      return setAlerts((prev) => [
        ...prev,
        {
          type: 'error',
          title: 'Permissão Negada',
          msg: 'Você não possui permissão para realizar essa ação.',
        },
      ])
    }

    const newJob = { ...schemaJobOffer(formContext?.formJobOffer), filledJob: 0 }

    if (Object.keys(newJob).length <= 1) {
      return
    }

    const dateExists = (dataContext?.jobOffers || []).some((jobOffers) => jobOffers.date === newJob.date)
    const positionExists = (dataContext?.jobOffers || []).some(
      (jobOffers) => jobOffers.idPosition === newJob.idPosition,
    )
    const roundExists = (dataContext?.jobOffers || []).some((jobOffers) => jobOffers.round === newJob.round)

    if (dateExists && positionExists && roundExists) {
      return setAlerts((prev) => [
        ...prev,
        {
          type: 'error',
          title: 'Vaga Já Existente',
          msg: `A vaga que está tentando adicionar já existe.`,
        },
      ])
    }

    const idJobOffers = await addSubDocument('events', idEvent, 'jobOffers', newJob)
    const idsPosition = [newJob.idPosition]
    // // console.log('idsPosition: ', idsPosition)
    await updateArrayInDocument('events', idEvent, 'idPositions', idsPosition)

    setDataContext((prev) => ({ ...prev, jobOffers: [...(prev?.jobOffers || []), { id: idJobOffers, ...newJob }] }))

    await deleteValuesFormJob()
    await FetchGetdatas()
    await FetchGetInfos()
    await SetHistoryEvent(
      idEvent,
      user.user.nome,
      `Vaga Criada: ${infosContext.positionsById[newJob.idPosition]} - ${newJob.date}`,
    )

    setAlerts((prev) => [
      ...prev,
      {
        type: 'success',
        title: 'Vaga Adicionada',
        msg: `Vaga adicionada ao evento ${formContext?.name} com sucesso.`,
      },
    ])

    return setActiveModal(false)
  }

  const CompareJobs = (jobBefore, newJob, excludeKeys = []) => {
    const differences = {}

    for (const key in jobBefore) {
      if (excludeKeys.includes(key)) continue // pula chave ignorada

      const beforeValue = jobBefore[key]
      const newValue = newJob[key]

      // Se for array (como o form), comparar item por item
      if (Array.isArray(beforeValue) && Array.isArray(newValue)) {
        if (beforeValue.length !== newValue.length) {
          differences[key] = { before: beforeValue, after: newValue }
          continue
        }

        const arrayDiffs = []
        beforeValue.forEach((item, index) => {
          const newItem = newValue[index]
          const itemDiff = {}

          // Só validar o título da pergunta
          if (item.title !== newItem.title) {
            itemDiff.title = { before: item.title, after: newItem.title }
          }

          if (Object.keys(itemDiff).length > 0) {
            arrayDiffs.push({ index, diff: itemDiff })
          }
        })

        if (arrayDiffs.length > 0) {
          differences[key] = arrayDiffs
        }
      }
      // Se não for array, comparar direto
      else if (beforeValue !== newValue) {
        differences[key] = { before: beforeValue, after: newValue }
      }
    }

    return differences
  }
  function translateFields(value) {
    const traducoes = {
      round: 'Turno',
      amountJob: 'Quantidade de vagas',
      date: 'Data',
      hrCheckin: 'Horário de entrada',
      hrCheckout: 'Horário de saída',
      hrStart: 'Horário de início',
      idPosition: 'Cargo',
      status: 'Status',
      value: 'Cachê',
      vestments: 'Fornece Vestimentas',
      food: 'Fornece Alimentação',
      food_value: 'Valor da alimentação',
      transportAllowance: 'Fornece Vale-transporte',
      transportAllowance_value: 'Valor do vale-transporte',
      register: 'Tipo de Registro',
      payment: 'Forma de pagamento',
      dtPayment: 'Data de pagamento',
      form: 'Formulário',
      0: 'Não Fornece',
      1: 'Fornece',
      2: 'Incluso no Cachê',
    }
    return traducoes?.[value] ? traducoes?.[value] : value
  }

  function generateChangeMessages(differences) {
    const linhas = []

    for (const key in differences) {
      const diff = differences[key]

      // Caso seja array (ex: form)
      if (Array.isArray(diff)) {
        diff.forEach((itemDiff) => {
          const { index, diff: changes } = itemDiff
          for (const field in changes) {
            const before = changes[field].before ?? 'não definido'
            const after = changes[field].after ?? 'não definido'
            linhas.push(
              `'Pergunta ${index + 1}' : Alterada de '${before}' para '${after}'. ` +
                `É necessário responder novamente esta pergunta;`,
            )
          }
        })
      } else {
        // Campo simples
        const campo = translateFields(key) || key
        const before = diff.before ?? 'não definido'
        const after = diff.after ?? 'não definido'
        linhas.push(
          ` - ${campo} : Valor anterior: '${translateFields(before)}'. Novo valor: '${translateFields(after)}';`,
        )
      }
    }

    if (linhas.length === 0) {
      return 'Nenhuma alteração encontrada.'
    }

    return `Campos modificados na vaga:\n\n${linhas.join('\n')}`
  }

  const sendAlertMessageInChat = async (msg, idJobOffer, jobOffer) => {
    const newMsg = {
      user: 'admin',
      jobOffers: [idJobOffer],
      message: msg,
      timestamp: TimestampNowSP(),
      name: 'Modificacao da Vaga',
      views: [],
    }

    await addSubDocument('events', id, 'messages', newMsg)

    const newNotificationEvent = {
      title: `${TransformationforMask(jobOffer?.name, 'title')} - ${TransformationforMask(jobOffer?.positionName, 'title')} - ${jobOffer?.date} - ${jobOffer?.round}`,
      msg,
      idEvent: id,
      dt_created: DateTimeNow(),
      created_by: 'Modificacao da Vaga',
      jobOffers: [idJobOffer],
    }

    await addDocument('_notificationsEvents', newNotificationEvent)
  }

  const editJobOffers = async () => {
    const idEvent = id
    const idJobOffer = formContext?.formJobOffer?.id || null

    if (!idJobOffer) {
      setAlerts((prev) => [
        ...prev,
        {
          type: 'error',
          title: 'idJobOffer não encontrado',
          msg: 'Acesse novamente o evento para coletar as informações necessárias e tente novamente realizar a ação anterior.',
        },
      ])
      return setActiveModal(false)
    }

    if (!user.user.permissions.jobOffers_edit) {
      return setAlerts((prev) => [
        ...prev,
        {
          type: 'error',
          title: 'Permissão Negada',
          msg: 'Você não possui permissão para realizar essa ação.',
        },
      ])
    }

    const reason = window.prompt('Justifique o motivo da edição da vaga:')

    if (reason === null || reason === '') {
      return setAlerts((prev) => [
        ...prev,
        {
          type: 'error',
          title: 'Justificativa obrigatória',
          msg: 'Para editar esta vaga, é necessario informar a justificativa.',
        },
      ])
    }

    const newJob = schemaJobOffer(formContext?.formJobOffer)
    const JobBefore = schemaJobOffer(formContext?.formJobOfferBefore)

    const hasChanges = CompareJobs(JobBefore, newJob, ['status'])

    const newMessageAlert = generateChangeMessages(hasChanges)

    if (Object.keys(newJob).length === 0) {
      return
    }

    await sendAlertMessageInChat(newMessageAlert, idJobOffer, {
      ...JobBefore,
      name: formContext?.name,
      positionName: infosContext.positionsById[newJob.idPosition],
    })

    await updateSubDocument('events', idEvent, 'jobOffers', idJobOffer, newJob)
    await updateArrayInDocument('events', idEvent, 'idPositions', [newJob.idPosition])

    // const newJobsData = (dataContext?.jobOffers || []).filter((job) => job.id !== idJobOffer)
    // console.log(newJobsData)

    await deleteValuesFormJob()
    await FetchGetdatas()
    await FetchGetInfos()

    await SetHistoryEvent(
      idEvent,
      user.user.nome,
      `Vaga Edita: ${infosContext.positionsById[newJob.idPosition]} - ${newJob.date} ${reason !== '' && `|| Motivo: ${reason}`}`,
    )

    setAlerts((prev) => [
      ...prev,
      {
        type: 'success',
        title: 'Vaga Editada',
        msg: `Vaga Editada com sucesso.`,
      },
    ])

    return setActiveModal(false)
  }

  const deleteValuesFormJob = async () => {
    const newJob = schemaJobOffer({})

    if (Object.keys(newJob).length === 0) {
      return
    }

    setFormContext((prev) => ({ ...prev, formJobOffer: newJob, formJobOfferBefore: newJob }))
  }

  const HandleAddJobOffers = async () => {
    await TryCatch(
      () => {
        addJobOffers()
      },
      setLoading,
      setAlerts,
    )
  }

  const HandleEditJobOffers = async (idJob) => {
    await TryCatch(
      () => {
        editJobOffers(idJob)
      },
      setLoading,
      setAlerts,
    )
  }

  const HandleDelValuesFormJob = async () => {
    await TryCatch(deleteValuesFormJob, setLoading, setAlerts)
  }

  return {
    loading,
    formContext,
    setFormContext,
    infosContext,
    HandleAddJobOffers,
    HandleEditJobOffers,
    HandleDelValuesFormJob,
    schemaJobOffer,
    FetchGetInfos,
    FetchGetdatas,
  }
}
